"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePicker = exports.StyledInputWrapper = exports.StyledLabelWrapper = exports.TRANSPARENT = void 0;
const React = __importStar(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const react_datepicker_1 = __importDefault(require("react-datepicker"));
require("react-datepicker/dist/react-datepicker.css");
const diem_1 = __importDefault(require("@travelnest/diem"));
const merlin_inline_message_1 = require("@travelnest/merlin.inline-message");
const merlin_spacer_1 = require("@travelnest/merlin.spacer");
const merlin_theme_1 = __importStar(require("@travelnest/merlin.theme"));
const merlin_typography_1 = require("@travelnest/merlin.typography");
const TABLET_BREAKPOINT = 800; // px
// Checks whether date input types are supported by the browser by creating one
// and seeing if it behaves as expected. Safari, for example, doesn't implement
// date type inputs.
const datePickerSupported = () => {
    const input = document.createElement('input');
    const value = 'a';
    input.setAttribute('type', 'date');
    input.setAttribute('value', value);
    return (input.value !== value);
};
exports.TRANSPARENT = 'rgba(0, 0, 0, 0)';
exports.StyledLabelWrapper = styled_1.default.div `
	font-family: ${merlin_theme_1.default.typography.fonts.base};
	font-size: ${merlin_theme_1.default.typography.c1.fontSize};
	line-height: ${merlin_theme_1.default.typography.c1.lineHeight};
	font-weight: 500;
	color: ${merlin_theme_1.default.colours.text.darkest};
	word-wrap: wrap
`;
// This wrapper adds a highlight outline on focus
// <div> needed as :after pseudo-element is not available on <input>
exports.StyledInputWrapper = styled_1.default.div `
	width: 100%;
	position: relative;

	:after {
		content: '';
		display: block;
		position: absolute;
		top: -2px;
		bottom: -2px;
		right: -2px;
		left: -2px;
		opacity: 0;
		border: 1px solid ${merlin_theme_1.default.colours.highlight.default};
		transition: opacity ${merlin_theme_1.default.motion.transition.default};
		-webkit-transition: opacity ${merlin_theme_1.default.motion.transition.default};
		pointer-events: none;
		border-radius: calc(${merlin_theme_1.default.layout.radius.squared} + 1px);
	}

	/* transition on opacity - fades in when focused */
	:focus-within:after {
		opacity: 1;
	}

	.merlin-datepicker__input {
		${merlin_theme_1.default.typography.c3};

		box-sizing: border-box;
		outline: none;
		border: 1px solid ${merlin_theme_1.default.colours.neutral.light};
		border-radius: ${merlin_theme_1.default.layout.radius.squared};
		height: 2.8125rem;
		background: #ffffff;
		width: 100%;
		padding: ${merlin_theme_1.default.layout.spacing.standard} ${merlin_theme_1.default.layout.spacing.small};
		transition: border 0.2s;

		${({ valid }) => !valid && `
			border-color: ${merlin_theme_1.default.colours.error.default};
			color: ${merlin_theme_1.default.colours.error.default};
			background-color: ${merlin_theme_1.default.colours.error.tint};
		`};

		&:focus, &:hover, &:active {
			border: 1px solid ${merlin_theme_1.default.colours.neutral.dark};
			${({ valid }) => !valid && `
				border-color: ${merlin_theme_1.default.colours.error.default};
				color: ${merlin_theme_1.default.colours.error.default};
				background-color: ${merlin_theme_1.default.colours.error.tint};
			`};
		}
		&:disabled, &:read-only {
			background: ${merlin_theme_1.default.colours.neutral.lighter};
			color: ${merlin_theme_1.default.colours.neutral.darker};
			cursor: not-allowed;
			opacity: 1;
		}
		&:disabled:hover, &:read-only:hover {
			border: 1px solid ${merlin_theme_1.default.colours.neutral.light};
		}

		-webkit-appearance: none;
	}

	:disabled {
		border-color: ${merlin_theme_1.default.palette.greyscale.dark};
		color: ${merlin_theme_1.default.palette.greyscale.darker};
		background-color: ${merlin_theme_1.default.palette.greyscale.lighter};
	}

	.merlin-datepicker__calendar {
		border-radius: 3px;
		font-family: ${merlin_theme_1.default.typography.fonts.base};
	}


	// ReactDatePicker style overrides

	.react-datepicker__input-container,
	.react-datepicker-wrapper {
		width: 100%;
	}

	.react-datepicker__header,
	.react-datepicker__today-button {
		background-color: ${merlin_theme_1.palette.greyscale.lightest};
	}

	.react-datepicker__header {
		border-top-left-radius: 3px;
		border-top-right-radius: 3px;
	}

	.react-datepicker__today-button {
		border-bottom-left-radius: 3px;
		border-bottom-right-radius: 3px;
	}

	.react-datepicker__day--selected {
		background-color: ${merlin_theme_1.default.colours.primary.default} !important;
		color: #fff !important;
	}

	.react-datepicker__day {
		border-radius: 4px;
		border: 1px solid ${exports.TRANSPARENT};
		outline: none;
	}

	.react-datepicker__day--keyboard-selected,
	.react-datepicker__day:focus,
	.react-datepicker__day:hover {
		border: 1px solid ${merlin_theme_1.default.colours.highlight.default};
		background-color: unset;
		color: #000;
		outline: none;
	}

	.react-datepicker__navigation:hover {
		border-left-color: ${merlin_theme_1.default.colours.highlight.default};
	}
	.react-datepicker__navigation:focus {
		outline: none;
	}
`;
// TODOJ NEXT:
// * Active date selection should be golden outline (no colour)
// * Cycling to new month (selects new day) should still use primary blue
const DatePicker = (props) => {
    const { label, value, valid, onChange, id, minDate, maxDate, overrideType, errorMessage } = props;
    const inputId = id || 'date-picker';
    // On small / mobile screens, we want to use the native date-picker input
    // where possible. We use 800px width as a rough heuristic for tablet size and
    // use the native picker at screen widths below that.
    const shouldUseNative = () => {
        // Use overrideType to force specific version in storybook / testing
        if (overrideType !== undefined) {
            return overrideType === 'native';
        }
        const tabletWidth = TABLET_BREAKPOINT;
        const portrait = window.innerWidth < window.innerHeight;
        const smallEnough = portrait ? window.innerWidth < tabletWidth : window.innerHeight < tabletWidth;
        return smallEnough && datePickerSupported();
    };
    const [useNative, setUseNative] = React.useState(shouldUseNative());
    React.useEffect(() => {
        const media = window.matchMedia(`(min-width: ${TABLET_BREAKPOINT}px)`);
        media.addListener(({ matches }) => setUseNative(!matches));
    }, []);
    const showLabel = label && (React.createElement(React.Fragment, null,
        React.createElement(merlin_typography_1.Label, { htmlFor: inputId }, label),
        React.createElement(merlin_spacer_1.Spacer, { spacing: "smaller" })));
    return (React.createElement("div", null,
        showLabel,
        React.createElement(exports.StyledInputWrapper, { valid: valid === undefined ? true : valid }, useNative ?
            React.createElement("input", { type: "date", placeholder: "dd/mm/yyyy", id: inputId, min: minDate, max: maxDate, value: (value === null || value === void 0 ? void 0 : value.toISOString()) || 'dd / mm / yyyy', className: "merlin-datepicker__input", onChange: (e) => {
                    const inputValue = e.target.value;
                    if (inputValue === undefined || inputValue === '') {
                        onChange(undefined);
                    }
                    else {
                        onChange(new diem_1.default(inputValue));
                    }
                } })
            :
                React.createElement(react_datepicker_1.default, { id: inputId, selected: value === null || value === void 0 ? void 0 : value.toDate(), dateFormat: 'dd/MM/yyyy', placeholderText: 'dd/mm/yyyy', minDate: minDate ? new Date(minDate) : undefined, maxDate: maxDate ? new Date(maxDate) : undefined, onChange: (date) => onChange(new diem_1.default(date)), todayButton: "Today", className: "merlin-datepicker__input", calendarClassName: "merlin-datepicker__calendar" })),
        !valid && errorMessage && (React.createElement(React.Fragment, null,
            React.createElement(merlin_spacer_1.Spacer, { spacing: "smaller" }),
            React.createElement(merlin_inline_message_1.InlineError, { text: errorMessage })))));
};
exports.DatePicker = DatePicker;
//# sourceMappingURL=DatePicker.js.map